import { createStyles, Theme } from '@material-ui/core'

export const conceptPriceEditDialogStyles = (theme: Theme) =>
  createStyles({
    dialogContent: {
      // Eliminar min-height del Toolbar del Form (espacio en blanco debajo del título)
      '& .MuiToolbar-regular': {
        minHeight: '0px !important',
        '@media (min-width: 0px) and (orientation: landscape)': {
          minHeight: '0px !important'
        },
        '@media (min-width: 600px)': {
          minHeight: '0px !important'
        }
      },
      // Eliminar padding del último CardContent (espacio en blanco al final del formulario)
      // sirve si hay otro componente debajo y queremos que parezca un solo bloque sin espacios
      '& .MuiCardContent-root:last-child': {
        paddingBottom: '0px !important'
      }
    }
  })
